<template>
  <div class="container-fluid">
    <div class="page-title">
      <div v-if="showUsuarios" class="row">
        <div class="col-6">
          <h3>Consultar clientes</h3>
        </div>
      </div>
    </div>
    <div v-if="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>
    <div v-else-if="errorMsg" class="alert alert-danger" role="alert">
      {{ errorMsg }}
    </div>
    <template v-else>
      <!-- Usuarios (cliente remitente) -->
      <div v-if="showUsuarios" class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header pb-0 d-flex justify-content-between align-items-center">
              <div>
                <h4>Usuarios (cliente remitente)</h4>
                <span>Alta y consulta de clientes remitentes.</span>
              </div>
              <div class="d-flex gap-2 flex-wrap justify-content-end">
                <report-export-buttons
                  title="Reporte de clientes remitentes"
                  subtitle="Consulta de usuarios clientes"
                  file-name="reporte-clientes-remitentes"
                  :columns="usuariosReportColumns"
                  :rows="usuariosReportRows"
                  :disabled="loading"
                />
                <button class="btn btn-primary btn-sm" @click="$router.push('/clientes/alta-cliente')">
                  Dar de alta cliente
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="row g-2 mb-3">
                <div class="col-md-3">
                  <label class="form-label mb-1 small">Buscar por nombre o correo</label>
                  <input v-model="filtersUsuarios.search" class="form-control form-control-sm" placeholder="Ej. Juan o correo@dominio.com" />
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Buscar por nombre</label>
                  <input v-model="filtersUsuarios.nombre" class="form-control form-control-sm" placeholder="Ej. Juan Garcia" />
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Buscar por correo</label>
                  <input v-model="filtersUsuarios.email" class="form-control form-control-sm" placeholder="correo@dominio.com" />
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Fecha creación desde</label>
                  <input v-model="filtersUsuarios.createdFrom" type="date" class="form-control form-control-sm" />
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Fecha creación hasta</label>
                  <input v-model="filtersUsuarios.createdTo" type="date" class="form-control form-control-sm" />
                </div>
                <div class="col-md-1 d-grid">
                  <label class="form-label mb-1 small">&nbsp;</label>
                  <button class="btn btn-outline-secondary btn-sm" @click="resetFilters('usuarios')">Limpiar</button>
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Filtrar por estado</label>
                  <select v-model="filtersUsuarios.activo" class="form-select form-select-sm">
                    <option value="ALL">Estado cuenta: todos</option>
                    <option value="true">Activos</option>
                    <option value="false">Inactivos</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Verificación teléfono</label>
                  <select v-model="filtersUsuarios.phoneVerified" class="form-select form-select-sm">
                    <option value="ALL">Verif. teléfono: todos</option>
                    <option value="true">Verificado</option>
                    <option value="false">Pendiente</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Verificación email</label>
                  <select v-model="filtersUsuarios.status" class="form-select form-select-sm">
                    <option value="ALL">Verif. email: todos</option>
                    <option value="ACTIVO">Verificado</option>
                    <option value="PENDIENTE">Pendiente</option>
                  </select>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Email</th><th>Nombre</th><th>Rol</th><th>Teléfono</th><th>Verif. Teléfono</th><th>Verificación</th><th>Estado</th><th>Fecha de registro</th><th class="text-end">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="paginatedUsuarios.length === 0"><td colspan="9" class="text-center text-muted py-4">No hay registros.</td></tr>
                    <tr v-for="client in paginatedUsuarios" :key="client.id">
                      <td>{{ client.email }}</td>
                      <td>{{ client.nombre || '-' }}</td>
                      <td><span class="badge badge-primary">Usuario</span></td>
                      <td>{{ client.phone || '-' }}</td>
                      <td><span class="badge" :class="client.phoneVerified ? 'badge-success' : 'badge-warning'">{{ client.phoneVerified ? 'Verificado' : 'Pendiente' }}</span></td>
                      <td><span class="badge" :class="client.status === 'ACTIVO' ? 'badge-success' : 'badge-warning'">{{ client.status === 'ACTIVO' ? 'Verificado' : 'Pendiente' }}</span></td>
                      <td><span class="badge" :class="client.activo === true ? 'badge-success' : 'badge-danger'">{{ client.activo === true ? 'Activo' : 'Inactivo' }}</span></td>
                      <td>{{ formatDate(client.createdAt) }}</td>
                      <td class="text-end">
                        <div class="btn-group">
                          <button type="button" class="btn btn-sm btn-outline-primary" title="Visualizar datos" @click="goToDetalle(client)"><vue-feather type="eye" size="14"></vue-feather></button>
                          <button type="button" class="btn btn-sm btn-warning text-dark" title="Actualizar información" data-bs-toggle="modal" data-bs-target="#clientEditModal" @click="openActualizar(client)"><vue-feather type="edit" size="14"></vue-feather></button>
                          <button type="button" class="btn btn-sm btn-outline-success" title="Verificar teléfono (código Vonage)" data-bs-toggle="modal" data-bs-target="#clientPhoneVerifyModal" :disabled="!client.phone || client.phoneVerified" @click="openVerificarTelefono(client)"><vue-feather type="check-circle" size="14"></vue-feather></button>
                          <button type="button" class="btn btn-sm btn-success" title="Marcar teléfono verificado (desarrollo, sin Vonage)" :disabled="!client.phone || client.phoneVerified || markingPhoneDevId === client.id" @click="marcarTelefonoVerificadoDev(client)"><vue-feather type="smartphone" size="14"></vue-feather></button>
                          <button type="button" class="btn btn-sm btn-outline-danger" title="Eliminar o desactivar cliente" @click="abrirModalOpcionesCliente(client)"><vue-feather type="trash-2" size="14"></vue-feather></button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="totalPagesUsuarios > 1" class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
                <small class="text-muted">Mostrando {{ fromItemUsuarios }} a {{ toItemUsuarios }} de {{ filteredUsuarios.length }} usuarios</small>
                <nav>
                  <ul class="pagination pagination-sm mb-0">
                    <li class="page-item" :class="{ disabled: currentPageUsuarios <= 1 }"><a class="page-link" href="javascript:void(0)" @click="currentPageUsuarios = Math.max(1, currentPageUsuarios - 1)">Anterior</a></li>
                    <li v-for="p in pageNumbersUsuarios" :key="`u-${p}`" class="page-item" :class="{ active: p === currentPageUsuarios }"><a class="page-link" href="javascript:void(0)" @click="currentPageUsuarios = p">{{ p }}</a></li>
                    <li class="page-item" :class="{ disabled: currentPageUsuarios >= totalPagesUsuarios }"><a class="page-link" href="javascript:void(0)" @click="currentPageUsuarios = Math.min(totalPagesUsuarios, currentPageUsuarios + 1)">Siguiente</a></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Viajeros -->
      <div v-if="showViajeros" class="row mt-3">
        <div class="col-12">
          <div class="card">
            <div class="card-header pb-0 d-flex justify-content-between align-items-center">
              <div>
                <h4>Viajeros (conductor)</h4>
                <span>Alta y consulta de conductores viajeros.</span>
              </div>
              <div class="d-flex gap-2 flex-wrap justify-content-end">
                <report-export-buttons
                  title="Reporte de viajeros"
                  subtitle="Consulta de conductores viajeros"
                  file-name="reporte-viajeros"
                  :columns="viajerosReportColumns"
                  :rows="viajerosReportRows"
                  :disabled="loading"
                />
                <button class="btn btn-primary btn-sm" @click="$router.push('/clientes/alta-viajero')">
                  Dar de alta viajero
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="row g-2 mb-3">
                <div class="col-md-3">
                  <label class="form-label mb-1 small">Buscar por nombre o correo</label>
                  <input v-model="filtersViajeros.search" class="form-control form-control-sm" placeholder="Ej. Juan o correo@dominio.com" />
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Buscar por nombre</label>
                  <input v-model="filtersViajeros.nombre" class="form-control form-control-sm" placeholder="Ej. Juan Garcia" />
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Buscar por correo</label>
                  <input v-model="filtersViajeros.email" class="form-control form-control-sm" placeholder="correo@dominio.com" />
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Fecha creación desde</label>
                  <input v-model="filtersViajeros.createdFrom" type="date" class="form-control form-control-sm" />
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Fecha creación hasta</label>
                  <input v-model="filtersViajeros.createdTo" type="date" class="form-control form-control-sm" />
                </div>
                <div class="col-md-1 d-grid">
                  <label class="form-label mb-1 small">&nbsp;</label>
                  <button class="btn btn-outline-secondary btn-sm" @click="resetFilters('viajeros')">Limpiar</button>
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Filtrar por estado</label>
                  <select v-model="filtersViajeros.activo" class="form-select form-select-sm">
                    <option value="ALL">Estado cuenta: todos</option>
                    <option value="true">Activos</option>
                    <option value="false">Inactivos</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Verificación teléfono</label>
                  <select v-model="filtersViajeros.phoneVerified" class="form-select form-select-sm">
                    <option value="ALL">Verif. teléfono: todos</option>
                    <option value="true">Verificado</option>
                    <option value="false">Pendiente</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label class="form-label mb-1 small">Verificación email</label>
                  <select v-model="filtersViajeros.status" class="form-select form-select-sm">
                    <option value="ALL">Verif. email: todos</option>
                    <option value="ACTIVO">Verificado</option>
                    <option value="PENDIENTE">Pendiente</option>
                  </select>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Email</th><th>Nombre</th><th>Rol</th><th>Teléfono</th><th>Verif. Teléfono</th><th>Verificación</th><th>Estado</th><th>Fecha de registro</th><th class="text-end">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="paginatedViajeros.length === 0"><td colspan="9" class="text-center text-muted py-4">No hay registros.</td></tr>
                    <tr v-for="client in paginatedViajeros" :key="client.id">
                      <td>{{ client.email }}</td>
                      <td>{{ client.nombre || '-' }}</td>
                      <td><span class="badge badge-info">Viajero</span></td>
                      <td>{{ client.phone || '-' }}</td>
                      <td><span class="badge" :class="client.phoneVerified ? 'badge-success' : 'badge-warning'">{{ client.phoneVerified ? 'Verificado' : 'Pendiente' }}</span></td>
                      <td><span class="badge" :class="client.status === 'ACTIVO' ? 'badge-success' : 'badge-warning'">{{ client.status === 'ACTIVO' ? 'Verificado' : 'Pendiente' }}</span></td>
                      <td><span class="badge" :class="client.activo === true ? 'badge-success' : 'badge-danger'">{{ client.activo === true ? 'Activo' : 'Inactivo' }}</span></td>
                      <td>{{ formatDate(client.createdAt) }}</td>
                      <td class="text-end">
                        <div class="btn-group">
                          <button type="button" class="btn btn-sm btn-outline-primary" title="Visualizar datos" @click="goToDetalle(client)"><vue-feather type="eye" size="14"></vue-feather></button>
                          <button type="button" class="btn btn-sm btn-warning text-dark" title="Actualizar información" data-bs-toggle="modal" data-bs-target="#clientEditModal" @click="openActualizar(client)"><vue-feather type="edit" size="14"></vue-feather></button>
                          <button type="button" class="btn btn-sm btn-outline-success" title="Verificar teléfono (código Vonage)" data-bs-toggle="modal" data-bs-target="#clientPhoneVerifyModal" :disabled="!client.phone || client.phoneVerified" @click="openVerificarTelefono(client)"><vue-feather type="check-circle" size="14"></vue-feather></button>
                          <button type="button" class="btn btn-sm btn-success" title="Marcar teléfono verificado (desarrollo, sin Vonage)" :disabled="!client.phone || client.phoneVerified || markingPhoneDevId === client.id" @click="marcarTelefonoVerificadoDev(client)"><vue-feather type="smartphone" size="14"></vue-feather></button>
                          <button type="button" class="btn btn-sm btn-outline-danger" title="Eliminar o desactivar cliente" @click="abrirModalOpcionesCliente(client)"><vue-feather type="trash-2" size="14"></vue-feather></button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="totalPagesViajeros > 1" class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
                <small class="text-muted">Mostrando {{ fromItemViajeros }} a {{ toItemViajeros }} de {{ filteredViajeros.length }} viajeros</small>
                <nav>
                  <ul class="pagination pagination-sm mb-0">
                    <li class="page-item" :class="{ disabled: currentPageViajeros <= 1 }"><a class="page-link" href="javascript:void(0)" @click="currentPageViajeros = Math.max(1, currentPageViajeros - 1)">Anterior</a></li>
                    <li v-for="p in pageNumbersViajeros" :key="`v-${p}`" class="page-item" :class="{ active: p === currentPageViajeros }"><a class="page-link" href="javascript:void(0)" @click="currentPageViajeros = p">{{ p }}</a></li>
                    <li class="page-item" :class="{ disabled: currentPageViajeros >= totalPagesViajeros }"><a class="page-link" href="javascript:void(0)" @click="currentPageViajeros = Math.min(totalPagesViajeros, currentPageViajeros + 1)">Siguiente</a></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- Modal Ver cliente (quick view estilo Tivo) -->
    <div class="modal fade" id="clientDetailModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title">Detalle del cliente</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div v-if="clienteSeleccionado" class="modal-body pt-0">
            <div class="row">
              <!-- Columna izquierda: avatar / resumen -->
              <div class="col-lg-5 mb-3 mb-lg-0 d-flex align-items-stretch">
                <div class="card w-100 shadow-sm border-0">
                  <div class="card-body text-center p-4">
                    <div
                      class="rounded-circle d-inline-flex align-items-center justify-content-center mb-3 overflow-hidden"
                      style="width: 72px; height: 72px; background: rgba(251, 201, 3, 0.15); color: #151824; font-weight: 700; font-size: 28px;"
                    >
                      <img
                        v-if="clienteSeleccionado.avatarUrl"
                        :src="avatarFullUrl(clienteSeleccionado.avatarUrl)"
                        alt="Avatar"
                        class="w-100 h-100 object-fit-cover"
                      />
                      <template v-else>{{ (clienteSeleccionado.nombre || clienteSeleccionado.email || '?').charAt(0).toUpperCase() }}</template>
                    </div>
                    <h5 class="mb-1">{{ clienteSeleccionado.nombre || 'Sin nombre' }}</h5>
                    <p class="text-muted mb-3 small">{{ clienteSeleccionado.email }}</p>
                    <div class="d-flex flex-column gap-2 align-items-center">
                      <span
                        class="badge"
                        :class="clienteSeleccionado.status === 'ACTIVO' ? 'badge-success' : 'badge-warning'"
                      >
                        {{ clienteSeleccionado.status === 'ACTIVO' ? 'Correo verificado' : 'Verificación pendiente' }}
                      </span>
                      <span
                        class="badge"
                        :class="clienteSeleccionado.phoneVerified ? 'badge-success' : 'badge-warning'"
                      >
                        {{
                          clienteSeleccionado.phoneVerified
                            ? 'Teléfono verificado'
                            : 'Verificación pendiente de teléfono'
                        }}
                      </span>
                      <span
                        class="badge"
                        :class="clienteSeleccionado.activo ? 'badge-success' : 'badge-secondary'"
                      >
                        {{ clienteSeleccionado.activo ? 'Cliente activo' : 'Cliente inactivo' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Columna derecha: datos detallados -->
              <div class="col-lg-7 d-flex align-items-stretch">
                <div class="card w-100 border-0">
                  <div class="card-body p-4">
                    <h6 class="f-w-600 mb-3">Información del cliente</h6>
                    <div class="row g-3">
                      <div class="col-sm-6">
                        <label class="text-muted small mb-1">Email</label>
                        <div class="fw-semibold text-break">{{ clienteSeleccionado.email }}</div>
                      </div>
                      <div class="col-sm-6">
                        <label class="text-muted small mb-1">Nombre</label>
                        <div class="fw-semibold">{{ clienteSeleccionado.nombre || '-' }}</div>
                      </div>
                      <div class="col-sm-6">
                        <label class="text-muted small mb-1">Rol</label>
                        <div class="fw-semibold">
                          <span class="badge" :class="clienteSeleccionado.role === 'CONDUCTOR_VIAJERO' ? 'badge-info' : 'badge-primary'">
                            {{ roleLabel(clienteSeleccionado.role) }}
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <label class="text-muted small mb-1">Teléfono</label>
                        <div class="fw-semibold">{{ clienteSeleccionado.phone || '-' }}</div>
                      </div>
                      <div class="col-sm-6">
                        <label class="text-muted small mb-1">Fecha de registro</label>
                        <div class="fw-semibold">{{ formatDate(clienteSeleccionado.createdAt) }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 pt-0">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Actualizar cliente (estilo quick view con formulario) -->
    <div class="modal fade" id="clientEditModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title">Actualizar cliente</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cerrarActualizar"></button>
          </div>
          <div v-if="clienteSeleccionado" class="modal-body pt-0">
            <div class="row">
              <!-- Columna izquierda: avatar / estado -->
              <div class="col-lg-5 mb-3 mb-lg-0 d-flex align-items-stretch">
                <div class="card w-100 shadow-sm border-0">
                  <div class="card-body text-center p-4">
                    <div
                      class="rounded-circle d-inline-flex align-items-center justify-content-center mb-3 overflow-hidden"
                      style="width: 72px; height: 72px; background: rgba(251, 201, 3, 0.15); color: #151824; font-weight: 700; font-size: 28px;"
                    >
                      <img
                        v-if="avatarPreviewUrl || clienteSeleccionado.avatarUrl"
                        :src="avatarPreviewUrl || avatarFullUrl(clienteSeleccionado.avatarUrl)"
                        alt="Avatar"
                        class="w-100 h-100 object-fit-cover"
                      />
                      <template v-else>{{ (clienteSeleccionado.nombre || clienteSeleccionado.email || '?').charAt(0).toUpperCase() }}</template>
                    </div>
                    <div class="mb-2">
                      <label class="form-label small text-muted">Foto de perfil</label>
                      <input
                        ref="avatarInputRef"
                        type="file"
                        accept="image/jpeg,image/png,image/webp,image/gif"
                        class="form-control form-control-sm"
                        @change="onAvatarFileChange"
                      />
                    </div>
                    <h5 class="mb-1">{{ clienteSeleccionado.nombre || 'Sin nombre' }}</h5>
                    <p class="text-muted mb-3 small">{{ clienteSeleccionado.email }}</p>
                    <div class="d-flex flex-column gap-2 align-items-center">
                      <span
                        class="badge"
                        :class="clienteSeleccionado.status === 'ACTIVO' ? 'badge-success' : 'badge-warning'"
                      >
                        {{ clienteSeleccionado.status === 'ACTIVO' ? 'Correo verificado' : 'Verificación pendiente' }}
                      </span>
                      <span
                        class="badge"
                        :class="clienteSeleccionado.phoneVerified ? 'badge-success' : 'badge-warning'"
                      >
                        {{
                          clienteSeleccionado.phoneVerified
                            ? 'Teléfono verificado'
                            : 'Verificación pendiente de teléfono'
                        }}
                      </span>
                      <span
                        class="badge"
                        :class="formActualizar.activo ? 'badge-success' : 'badge-secondary'"
                      >
                        {{ formActualizar.activo ? 'Cliente activo' : 'Cliente inactivo' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Columna derecha: formulario editable -->
              <div class="col-lg-7 d-flex align-items-stretch">
                <div class="card w-100 border-0">
                  <div class="card-body p-4">
                    <h6 class="f-w-600 mb-3">Información editable</h6>
                    <div class="mb-3">
                      <label class="form-label">Email</label>
                      <input
                        type="email"
                        class="form-control"
                        :value="clienteSeleccionado.email"
                        disabled
                      />
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Nombre</label>
                      <input v-model="formActualizar.nombre" type="text" class="form-control" placeholder="Nombre" />
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Teléfono</label>
                      <input v-model="formActualizar.phone" type="tel" class="form-control" placeholder="Teléfono" />
                    </div>
                    <div class="mb-3">
                      <div class="form-check form-switch">
                        <input v-model="formActualizar.activo" class="form-check-input" type="checkbox" id="activoSwitch" />
                        <label class="form-check-label" for="activoSwitch">Activo</label>
                      </div>
                    </div>
                    <div v-if="errorActualizar" class="alert alert-danger py-2">{{ errorActualizar }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 pt-0">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="cerrarActualizar">Cancelar</button>
            <button type="button" class="btn btn-primary" :disabled="loadingActualizar" @click="guardarActualizar">
              {{ loadingActualizar ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Verificar teléfono -->
    <div
      class="modal fade"
      id="clientPhoneVerifyModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title">Verificar teléfono</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div v-if="clienteSeleccionado" class="modal-body pt-0">
            <div class="mb-3">
              <label class="form-label">Teléfono</label>
              <div class="fw-semibold">{{ clienteSeleccionado.phone || '-' }}</div>
            </div>
            <div class="mb-3">
              <label class="form-label">Código SMS</label>
              <input
                v-model="formVerificarTelefono.code"
                type="text"
                class="form-control"
                placeholder="Ej. 123456"
                inputmode="numeric"
              />
            </div>
            <div v-if="errorVerificarTelefono" class="alert alert-danger py-2">
              {{ errorVerificarTelefono }}
            </div>
          </div>
          <div class="modal-footer border-0 pt-0">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :disabled="loadingVerificarTelefono || !formVerificarTelefono.code"
              @click="confirmarVerificacionTelefono"
            >
              {{ loadingVerificarTelefono ? 'Verificando...' : 'Verificar teléfono' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Opciones: Eliminar datos o Desactivar -->
    <div class="modal fade modal-opciones-cliente" :class="{ show: modalOpcionesCliente }" :style="modalOpcionesCliente ? 'display: block' : ''" tabindex="-1">
      <div v-if="modalOpcionesCliente" class="modal-backdrop modal-backdrop-light fade show"></div>
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h5 class="modal-title">Acción sobre el cliente</h5>
            <button type="button" class="btn-close" @click="cerrarModalOpciones"></button>
          </div>
          <div class="modal-body">
            <p v-if="clienteAEliminar" class="mb-4">
              Cliente: <strong>{{ clienteAEliminar.email }}</strong>
            </p>
            <p class="text-muted small mb-3">Elija una opción:</p>
            <div class="d-flex flex-column gap-2">
              <button
                type="button"
                class="btn btn-danger d-flex align-items-center justify-content-between"
                :disabled="loadingEliminar || loadingEliminarPermanent"
                @click="ejecutarEliminarPermanent"
              >
                <span>Eliminar datos del cliente</span>
                <vue-feather v-if="!loadingEliminarPermanent" type="trash-2" size="18"></vue-feather>
                <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
              <p class="small text-muted mb-0 ms-2">Se borrará el registro de forma permanente. Esta acción no se puede deshacer.</p>
              <button
                type="button"
                class="btn btn-warning text-dark d-flex align-items-center justify-content-between mt-2"
                :disabled="loadingEliminar || loadingEliminarPermanent"
                @click="ejecutarDesactivar"
              >
                <span>Desactivar</span>
                <vue-feather v-if="!loadingEliminar" type="user-x" size="18"></vue-feather>
                <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
              <p class="small text-muted mb-0 ms-2">Solo se actualizará el estado a inactivo. El cliente seguirá en el sistema.</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" :disabled="loadingEliminar || loadingEliminarPermanent" @click="cerrarModalOpciones">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { clientsApi } from '@/api/clients';
import ReportExportButtons from '@/components/reports/ReportExportButtons.vue';

const PAGE_SIZE = 10;

export default {
  name: 'ConsultarClientes',
  components: { ReportExportButtons },
  data() {
    const defaultFilters = () => ({
      search: '',
      nombre: '',
      email: '',
      createdFrom: '',
      createdTo: '',
      activo: 'ALL',
      phoneVerified: 'ALL',
      status: 'ALL',
    });

    return {
      sectionMode: 'both',
      clients: [],
      loading: false,
      errorMsg: '',
      currentPageUsuarios: 1,
      currentPageViajeros: 1,
      pageSize: PAGE_SIZE,
      filtersUsuarios: defaultFilters(),
      filtersViajeros: defaultFilters(),
      modalActualizar: false,
      modalEliminar: false,
      modalOpcionesCliente: false,
      clienteSeleccionado: null,
      clienteAEliminar: null,
      formActualizar: { nombre: '', phone: '', activo: true },
      errorActualizar: '',
      loadingActualizar: false,
      formVerificarTelefono: { code: '' },
      errorVerificarTelefono: '',
      loadingVerificarTelefono: false,
      markingPhoneDevId: null,
      loadingEliminar: false,
      loadingEliminarPermanent: false,

      avatarFile: null,
      avatarPreviewUrl: null,
    };
  },
  computed: {
    showUsuarios() {
      return this.sectionMode === 'both' || this.sectionMode === 'usuarios';
    },
    showViajeros() {
      return this.sectionMode === 'both' || this.sectionMode === 'viajeros';
    },
    usuarios() {
      return this.clients.filter((c) => c.registerRemitente === true);
    },
    viajeros() {
      return this.clients.filter((c) => c.registerViajero === true);
    },
    filteredUsuarios() {
      return this.usuarios.filter((c) => this.matchesFilters(c, this.filtersUsuarios));
    },
    filteredViajeros() {
      return this.viajeros.filter((c) => this.matchesFilters(c, this.filtersViajeros));
    },
    totalPagesUsuarios() {
      return Math.max(1, Math.ceil(this.filteredUsuarios.length / this.pageSize));
    },
    totalPagesViajeros() {
      return Math.max(1, Math.ceil(this.filteredViajeros.length / this.pageSize));
    },
    fromItemUsuarios() {
      return this.filteredUsuarios.length === 0 ? 0 : (this.currentPageUsuarios - 1) * this.pageSize + 1;
    },
    toItemUsuarios() {
      return Math.min(this.currentPageUsuarios * this.pageSize, this.filteredUsuarios.length);
    },
    fromItemViajeros() {
      return this.filteredViajeros.length === 0 ? 0 : (this.currentPageViajeros - 1) * this.pageSize + 1;
    },
    toItemViajeros() {
      return Math.min(this.currentPageViajeros * this.pageSize, this.filteredViajeros.length);
    },
    pageNumbersUsuarios() {
      const pages = [];
      for (let i = 1; i <= this.totalPagesUsuarios; i++) pages.push(i);
      return pages;
    },
    pageNumbersViajeros() {
      const pages = [];
      for (let i = 1; i <= this.totalPagesViajeros; i++) pages.push(i);
      return pages;
    },
    paginatedUsuarios() {
      const start = (this.currentPageUsuarios - 1) * this.pageSize;
      return this.filteredUsuarios.slice(start, start + this.pageSize);
    },
    paginatedViajeros() {
      const start = (this.currentPageViajeros - 1) * this.pageSize;
      return this.filteredViajeros.slice(start, start + this.pageSize);
    },
    usuariosReportColumns() {
      return [
        { key: 'email', label: 'Email' },
        { key: 'nombre', label: 'Nombre' },
        { key: 'rol', label: 'Rol' },
        { key: 'phone', label: 'Teléfono' },
        { key: 'phoneVerified', label: 'Verif. teléfono' },
        { key: 'status', label: 'Verificación email' },
        { key: 'activo', label: 'Estado cuenta' },
        { key: 'createdAt', label: 'Fecha de registro' },
      ];
    },
    usuariosReportRows() {
      return this.filteredUsuarios.map((client) => ({
        email: client.email || '-',
        nombre: client.nombre || '-',
        rol: 'Usuario',
        phone: client.phone || '-',
        phoneVerified: client.phoneVerified ? 'Verificado' : 'Pendiente',
        status: client.status === 'ACTIVO' ? 'Verificado' : 'Pendiente',
        activo: client.activo ? 'Activo' : 'Inactivo',
        createdAt: this.formatDate(client.createdAt),
      }));
    },
    viajerosReportColumns() {
      return [
        { key: 'email', label: 'Email' },
        { key: 'nombre', label: 'Nombre' },
        { key: 'rol', label: 'Rol' },
        { key: 'phone', label: 'Teléfono' },
        { key: 'phoneVerified', label: 'Verif. teléfono' },
        { key: 'status', label: 'Verificación email' },
        { key: 'activo', label: 'Estado cuenta' },
        { key: 'createdAt', label: 'Fecha de registro' },
      ];
    },
    viajerosReportRows() {
      return this.filteredViajeros.map((client) => ({
        email: client.email || '-',
        nombre: client.nombre || '-',
        rol: 'Viajero',
        phone: client.phone || '-',
        phoneVerified: client.phoneVerified ? 'Verificado' : 'Pendiente',
        status: client.status === 'ACTIVO' ? 'Verificado' : 'Pendiente',
        activo: client.activo ? 'Activo' : 'Inactivo',
        createdAt: this.formatDate(client.createdAt),
      }));
    },
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler() {
        this.syncSectionModeFromRoute();
      },
    },
    filteredUsuarios() {
      if (this.currentPageUsuarios > this.totalPagesUsuarios) this.currentPageUsuarios = this.totalPagesUsuarios;
    },
    filteredViajeros() {
      if (this.currentPageViajeros > this.totalPagesViajeros) this.currentPageViajeros = this.totalPagesViajeros;
    }
  },
  mounted() {
    this.fetchClients();
    window.addEventListener('focus', this.onWindowFocus);
  },
  methods: {
    syncSectionModeFromRoute() {
      const rawSection = this.$route?.query?.section;
      const sectionFromQuery = Array.isArray(rawSection)
        ? (rawSection[0] || '').toString().trim().toLowerCase()
        : (rawSection || '').toString().trim().toLowerCase();

      if (sectionFromQuery === 'usuarios' || sectionFromQuery === 'viajeros') {
        this.sectionMode = sectionFromQuery;
        return;
      }

      // fallback robusto por si la navegación llega con query embebido en fullPath
      const fullPath = (this.$route?.fullPath || '').toLowerCase();
      if (fullPath.includes('section=usuarios')) {
        this.sectionMode = 'usuarios';
      } else if (fullPath.includes('section=viajeros')) {
        this.sectionMode = 'viajeros';
      } else {
        this.sectionMode = 'both';
      }
    },
    roleLabel(role) {
      if (role === 'CONDUCTOR_VIAJERO') return 'Viajero';
      if (role === 'CLIENTE_REMITENTE') return 'Usuario';
      return role || '-';
    },
    async fetchClients() {
      if (!this.loading) {
        this.loading = true;
      }
      this.errorMsg = '';
      try {
        const { data } = await clientsApi.getAll();
        this.clients = data || [];
        this.currentPageUsuarios = 1;
        this.currentPageViajeros = 1;
      } catch (e) {
        this.errorMsg = e.response?.data?.message || 'Error al cargar clientes.';
      } finally {
        this.loading = false;
      }
    },
    onWindowFocus() {
      this.fetchClients();
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      return d.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
    normalizeText(v) {
      return (v || '').toString().toLowerCase().trim();
    },
    dateOnly(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      if (Number.isNaN(d.getTime())) return '';
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    matchesFilters(client, filters) {
      const fullSearch = this.normalizeText(filters.search);
      const nombre = this.normalizeText(client.nombre);
      const email = this.normalizeText(client.email);

      if (fullSearch && !nombre.includes(fullSearch) && !email.includes(fullSearch)) return false;
      if (filters.nombre && !nombre.includes(this.normalizeText(filters.nombre))) return false;
      if (filters.email && !email.includes(this.normalizeText(filters.email))) return false;

      const created = this.dateOnly(client.createdAt);
      if (filters.createdFrom && created < filters.createdFrom) return false;
      if (filters.createdTo && created > filters.createdTo) return false;

      if (filters.activo !== 'ALL' && String(Boolean(client.activo)) !== filters.activo) return false;
      if (filters.phoneVerified !== 'ALL' && String(Boolean(client.phoneVerified)) !== filters.phoneVerified) return false;
      if (filters.status !== 'ALL' && (client.status || '') !== filters.status) return false;

      return true;
    },
    resetFilters(tipo) {
      const empty = {
        search: '',
        nombre: '',
        email: '',
        createdFrom: '',
        createdTo: '',
        activo: 'ALL',
        phoneVerified: 'ALL',
        status: 'ALL',
      };
      if (tipo === 'usuarios') {
        this.filtersUsuarios = { ...empty };
        this.currentPageUsuarios = 1;
        return;
      }
      this.filtersViajeros = { ...empty };
      this.currentPageViajeros = 1;
    },
    openVerificarTelefono(client) {
      this.clienteSeleccionado = { ...client };
      this.formVerificarTelefono = { code: '' };
      this.errorVerificarTelefono = '';
      this.loadingVerificarTelefono = false;
    },
    async marcarTelefonoVerificadoDev(client) {
      if (!client?.id || !client.phone || client.phoneVerified) return;

      const confirm = await Swal.fire({
        icon: 'warning',
        title: 'Verificar teléfono (desarrollo)',
        html: `Se marcará como <strong>verificado</strong> el teléfono de<br><strong>${client.email}</strong><br>sin enviar SMS (Vonage).`,
        showCancelButton: true,
        confirmButtonText: 'Sí, marcar verificado',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#198754',
      });
      if (!confirm.isConfirmed) return;

      this.markingPhoneDevId = client.id;
      try {
        await clientsApi.markPhoneVerified(client.id);
        await Swal.fire({
          icon: 'success',
          title: 'Teléfono verificado',
          text: 'El usuario ya puede usar la app con teléfono verificado. Pídele cerrar sesión y volver a entrar en la app móvil.',
          confirmButtonColor: '#0d6efd',
        });
        await this.fetchClients();
      } catch (e) {
        const msg = e.response?.data?.message || e.message || 'No se pudo marcar el teléfono.';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: Array.isArray(msg) ? msg.join(' ') : msg,
          confirmButtonColor: '#0d6efd',
        });
      } finally {
        this.markingPhoneDevId = null;
      }
    },
    async confirmarVerificacionTelefono() {
      if (!this.clienteSeleccionado) return;
      this.loadingVerificarTelefono = true;
      this.errorVerificarTelefono = '';

      try {
        const payload = { code: this.formVerificarTelefono.code };
        await clientsApi.verifyPhone(this.clienteSeleccionado.id, payload);

        await Swal.fire({
          icon: 'success',
          title: 'Teléfono verificado',
          text: 'La verificación del teléfono se realizó correctamente.',
          confirmButtonColor: '#0d6efd',
        });

        const modalEl = document.getElementById('clientPhoneVerifyModal');
        const bsModal = modalEl && window.bootstrap?.Modal?.getOrCreateInstance(modalEl);
        if (bsModal) bsModal.hide();

        this.formVerificarTelefono.code = '';
        await this.fetchClients();
      } catch (e) {
        const msg = e.response?.data?.message || e.message || 'Error al verificar el teléfono.';
        this.errorVerificarTelefono = Array.isArray(msg) ? msg.join(' ') : msg;
      } finally {
        this.loadingVerificarTelefono = false;
      }
    },
    openVer(client) {
      this.clienteSeleccionado = { ...client };
    },
    goToDetalle(client) {
      if (!client?.id) return;
      this.$router.push({ name: 'detalle-cliente', params: { id: client.id } });
    },
    avatarFullUrl(avatarUrl) {
      if (!avatarUrl) return '';
      const base = process.env.VUE_APP_API_URL || 'http://localhost:3000';
      let url = avatarUrl.startsWith('http')
        ? avatarUrl
        : `${base.replace(/\/$/, '')}${avatarUrl.startsWith('/') ? '' : '/'}${avatarUrl}`;
      // Fuerza a recargar siempre la imagen evitando cache del navegador
      const sep = url.includes('?') ? '&' : '?';
      return `${url}${sep}v=${Date.now()}`;
    },
    onAvatarFileChange(e) {
      const file = e.target.files?.[0];
      if (this.avatarPreviewUrl) {
        URL.revokeObjectURL(this.avatarPreviewUrl);
        this.avatarPreviewUrl = null;
      }
      this.avatarFile = file || null;
      if (file) {
        this.avatarPreviewUrl = URL.createObjectURL(file);
      }
    },
    openActualizar(client) {
      this.clienteSeleccionado = { ...client };
      this.formActualizar = {
        nombre: client.nombre || '',
        phone: client.phone || '',
        activo: !!client.activo,
      };
      this.errorActualizar = '';
      if (this.avatarPreviewUrl) {
        URL.revokeObjectURL(this.avatarPreviewUrl);
      }
      this.avatarPreviewUrl = null;
      this.avatarFile = null;
      this.$nextTick(() => {
        if (this.$refs.avatarInputRef) this.$refs.avatarInputRef.value = '';
      });
      this.modalActualizar = true;
    },
    cerrarActualizar() {
      if (this.avatarPreviewUrl) {
        URL.revokeObjectURL(this.avatarPreviewUrl);
      }
      this.avatarPreviewUrl = null;
      this.avatarFile = null;
      this.modalActualizar = false;
      this.clienteSeleccionado = null;
      this.errorActualizar = '';
    },
    async guardarActualizar() {
      if (!this.clienteSeleccionado) return;
      this.loadingActualizar = true;
      this.errorActualizar = '';
      try {
        if (this.avatarFile) {
          await clientsApi.uploadAvatar(this.clienteSeleccionado.id, this.avatarFile);
        }
        const payload = {
          nombre: this.formActualizar.nombre ?? '',
          phone: this.formActualizar.phone ?? '',
          activo: Boolean(this.formActualizar.activo),
        };
        await clientsApi.update(this.clienteSeleccionado.id, payload);
        const showSuccess = () => {
          this.cerrarActualizar();
          this.fetchClients();
          this.loadingActualizar = false;
          Swal.fire({
            icon: 'success',
            title: 'Datos actualizados',
            text: 'Los datos del cliente se han actualizado correctamente.',
            confirmButtonColor: '#0d6efd',
          });
        };

        const modalEl = document.getElementById('clientEditModal');
        const bsModal = modalEl && window.bootstrap?.Modal?.getOrCreateInstance(modalEl);
        if (bsModal) {
          const onHidden = () => {
            modalEl.removeEventListener('hidden.bs.modal', onHidden);
            showSuccess();
          };
          modalEl.addEventListener('hidden.bs.modal', onHidden, { once: true });
          bsModal.hide();
        } else {
          if (modalEl) {
            modalEl.classList.remove('show');
            modalEl.style.display = 'none';
            document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
            document.body.classList.remove('modal-open');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('padding-right');
          }
          showSuccess();
        }
      } catch (e) {
        const msg = e.response?.data?.message;
        this.errorActualizar = Array.isArray(msg) ? msg.join(' ') : (msg || e.message || 'Error al actualizar.');
      } finally {
        this.loadingActualizar = false;
      }
    },
    abrirModalOpcionesCliente(client) {
      this.clienteAEliminar = client;
      this.modalOpcionesCliente = true;
    },
    cerrarModalOpciones() {
      if (this.loadingEliminar || this.loadingEliminarPermanent) return;
      this.modalOpcionesCliente = false;
      this.clienteAEliminar = null;
    },
    async ejecutarEliminarPermanent() {
      if (!this.clienteAEliminar) return;
      this.loadingEliminarPermanent = true;
      try {
        await clientsApi.deletePermanent(this.clienteAEliminar.id);
        const email = this.clienteAEliminar.email;
        this.modalOpcionesCliente = false;
        this.clienteAEliminar = null;
        await this.fetchClients();
        await Swal.fire({
          icon: 'success',
          title: 'Cliente eliminado',
          text: `Los datos del cliente ${email} han sido eliminados permanentemente.`,
          confirmButtonColor: '#0d6efd',
        });
      } catch (e) {
        this.errorMsg = e.response?.data?.message || 'Error al eliminar el cliente.';
      } finally {
        this.loadingEliminarPermanent = false;
      }
    },
    async ejecutarDesactivar() {
      if (!this.clienteAEliminar) return;
      this.loadingEliminar = true;
      try {
        await clientsApi.delete(this.clienteAEliminar.id);
        const email = this.clienteAEliminar.email;
        this.modalOpcionesCliente = false;
        this.clienteAEliminar = null;
        await this.fetchClients();
        await Swal.fire({
          icon: 'success',
          title: 'Cliente desactivado',
          text: `El cliente ${email} ha sido desactivado. El estado se ha actualizado a inactivo.`,
          confirmButtonColor: '#0d6efd',
        });
      } catch (e) {
        this.errorMsg = e.response?.data?.message || 'Error al desactivar cliente.';
      } finally {
        this.loadingEliminar = false;
      }
    },
  },
};
</script>

<style scoped>
/* Backdrop más suave para no bajar tanto el contraste del fondo */
.modal-backdrop-light {
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 1;
}
/* Para este modal, el backdrop es solo visual: no debe interceptar clics */
.modal-opciones-cliente .modal-backdrop {
  pointer-events: none;
}
</style>
